export default function getBackgroundColorCode(currentType: string): string {
  return currentType === "booking"
    ? "#7209AF"
    : currentType === "rental"
      ? "#03A70C"
      : currentType === "wanted"
        ? "#D2691E"
        : "#DC3545";
}
